export enum PreferredEmployeeCreatedBy {
  EMPLOYEE = 'EMPLOYEE',
  PLANNER = 'PLANNER',
  FLEX_PLANNER = 'FLEX_PLANNER',
  EXTERNAL_PLANNER = 'EXTERNAL_PLANNER'
}
